import {Chip} from "@material-ui/core";
import ChipInput from "material-ui-chip-input";


export default function ChipList({items,label}) {
    if (!items || items.length === 0) {
        return null;
    }
    const chipRenderer = ({value, text, className}, key) => (
        <Chip
            key={key}
            className={className}
            style={{pointerEvents: 'none' }}
            label={value}
        />
    )
    return (<ChipInput style={{margin: '8px 0'}}
                       variant="outlined" label={label} fullWidth
                       chipRenderer={chipRenderer}
                       defaultValue={items} disabled/>);
}